import { HorizontalContainer, Wrapper } from '@american-autonomy/ag-ui';

import GhostButton from 'components/buttons/GhostButton';

import { DETACH_BUTTON_TEST_ID, TEST_ID, ZONE_COUNT_TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

// Tiny status row that surfaces the loaded zone count and a detach action
// once a prescription is attached. Kept as its own subcomponent (with no
// styles file — appearance comes from the parent section's `footer` class)
// so PrescriptionSection can stay under the 100-line component budget while
// still keeping each branch of the upload/loaded ternary readable.
const PrescriptionStatusRow: FunctionComponent<Props> = ({
    className = '',
    detachText,
    isDetachDisabled,
    onDetach,
    testId = TEST_ID,
    zoneCountText
}) => (
    <HorizontalContainer className={className} testId={testId}>
        <Wrapper testId={ZONE_COUNT_TEST_ID}>{zoneCountText}</Wrapper>

        <GhostButton
            isDisabled={isDetachDisabled}
            onClick={onDetach}
            testId={DETACH_BUTTON_TEST_ID}
            text={detachText}
        />
    </HorizontalContainer>
);

export default PrescriptionStatusRow;
